/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum EstadoOperacionEnum {
  Pendiente = 0,
  Iniciada = 1,
  Finalizada = 2
}
